export default __webpack_public_path__ + "static/media/prada2.1cf495da.jpg";